import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/lib/supabase';
import { PageContainer } from '@/components/layout/PageContainer';

export function AuthConfirmPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const handleEmailConfirmation = async () => {
      try {
        // Supabase가 자동으로 URL 파라미터를 처리하고 세션을 설정합니다
        const { data: { session }, error } = await supabase.auth.getSession();
        
        if (error) {
          console.error('Auth confirmation error:', error);
          navigate('/login', { replace: true });
          return;
        }

        if (session) {
          console.log('Email confirmed successfully');
          // 인증이 완료되었으므로 로그아웃 후 로그인 페이지로 이동
          await supabase.auth.signOut();
          navigate('/login', { 
            replace: true,
            state: { message: '이메일 인증이 완료되었습니다. 로그인해주세요.' }
          });
        } else {
          // 세션이 없으면 로그인 페이지로
          navigate('/login', { replace: true });
        }
      } catch (error) {
        console.error('Auth confirm error:', error);
        navigate('/login', { replace: true });
      }
    };

    // Supabase가 URL 파라미터를 처리할 시간을 주기 위해 약간의 지연
    setTimeout(handleEmailConfirmation, 1000);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-white">
      <PageContainer>
        <div className="flex flex-col items-center justify-center min-h-[60vh]">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-500 mb-4"></div>
          <p className="text-gray-600">이메일 인증 처리 중...</p>
        </div>
      </PageContainer>
    </div>
  );
}